function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.904 3.142a.447.447 0 01.653 0l4.308 4.516a.5.5 0 010 .684l-4.308 4.516a.447.447 0 01-.653 0 .5.5 0 010-.684l3.52-3.69H2.462A.473.473 0 012 8c0-.267.207-.484.462-.484h9.962l-3.52-3.69a.5.5 0 010-.684z",
  fill: "#2D2D2D"
});
function SvgFlechaaladerecha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Flecha a la derecha.svg";
export { SvgFlechaaladerecha as ReactComponent };